import * as React from "react";

function IconLOStarter({ ...props }) {

  return (
    <svg width={72} height={72} fill="none" {...props}>
  <path
    d="M70.5 36.375c0 19.26-15.614 34.875-34.875 34.875C16.365 71.25.75 55.636.75 36.375.75 17.115 16.364 1.5 35.625 1.5 54.885 1.5 70.5 17.114 70.5 36.375z"
    fill="#eeff41"
  />
  <path
    d="M35.625 2C54.61 2 70 17.39 70 36.375S54.61 70.75 35.625 70.75 1.25 55.36 1.25 36.375 16.64 2 35.625 2z"
    stroke="#000"
    strokeOpacity={0.08}
  />
  <path
    d="M35.505 18.128l-20.46 15.74 4.286 5.572 2.1-1.614v14.513h28.15V37.826l2.099 1.614 4.286-5.572-20.46-15.74zm2.04 31.81h-4.08v-8.584h4.08v8.584zm9.635 0h-7.234V38.953h-8.882v10.985h-7.233v-13.96l11.674-8.98 11.675 8.98v13.96zm4.06-13.864l-1.66-1.277-2.782-2.14-11.293-8.688L19.77 36.074l-1.36-1.767 17.095-13.15L52.6 34.306l-1.36 1.767z"
    fill="#170F49"
  />
</svg>
  );
}

const MemoIconLOStarter = React.memo(IconLOStarter);
export default MemoIconLOStarter;
